import PopUpSearch from './PopUpSearch';

export default PopUpSearch;
